


































































































































































import {Component, Vue, Watch} from 'vue-property-decorator';
import Client from '@/data/models/client';
import Building from '@/data/models/building';
import DateUtils from '@/helpers/date-utils';
import {AvailablePeriodType} from '@/data/models/enums/available-period-type';
import BuildingMeters from '@/data/models/building-meters';
import Meter from '@/data/models/meter';
import {REF_METER_TYPE} from '@/constants';
import {MeterType} from '@/data/models/enums/meter-enum';
import StatsConsumptionForm from '@/data/models/StatsConsumptionForm';
import ConsumptionChart from '@/components/dashboard/ConsumptionChart.vue';
import StatsConsumptionResponse from '@/data/models/StatsConsumptionResponse';
import MeterReadingMonthlyAggregated from '@/data/models/meter-reading-monthly-aggregated';
import ConsumptionsDistributionChart from '@/components/dashboard/ConsumptionsDistributionChart.vue';
import StatsConsumptionDistributionResponse from '@/data/models/StatsConsumptionDistributionResponse';
import DashboardTemplate from '@/components/dashboard/DashboardTemplate.vue';
import EnergeticChart from '@/components/dashboard/EnergeticChart.vue';
import StatsForm from '@/data/models/StatsForm';
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import ModelResultDailyAggregated from "@/data/models/model-result-daily-aggregated";
import {exportCSVFile} from "@/helpers/utils";
import GetTemperatureDataForm from "@/data/models/getTemperatureDataForm";
import MeterReading from "@/data/models/meter-reading";
import ClientBuildings from "@/data/models/client-buildings";

dayjs.extend(utc);

@Component({
  components: {EnergeticChart, DashboardTemplate, ConsumptionChart, ConsumptionsDistributionChart}
})
export default class Home extends Vue {
  datePickerOpen: boolean = false;
  isListDisplay: boolean = false;
  isRatio: boolean = false;

  currentClient: Client = null;
  allClients: Client[] = [];

  statConsumptionDistribution: StatsConsumptionDistributionResponse[] = null;
  statEnergetic: StatsConsumptionResponse<ModelResultDailyAggregated>[] = null;
  statConsumption: StatsConsumptionResponse<any>[] = null;
  statTemperature: any[] = null;
  meterTemperature: Meter = null;

  exporting = false;
  // Des index bruts (idx_conso) existent-ils pour les compteurs et l'intervalle de l'analyse en cours ?
  hasIndexes = false;

  chartsLoading = {
    loadingConsumptionData: false,
    loadingConsumptionDistributionData: false,
    loadingEnergeticData: false,
    loadingTemperatureData: false
  };

  selectedBuilding: Building[] = [];
  selectedMeters: Meter[] = [];
  selectedTypes: MeterType[] = [];

  selectedDate: Date = dayjs.utc().startOf('month').toDate();
  selectedPeriod: AvailablePeriodType = AvailablePeriodType.DAY;

  date: string = dayjs.utc().toISOString();

  shouldBeInverted = false;

  beforeMount(): void {
    this.extractPathParameters();
  }

  mounted(): void {
    this.$store.commit("showLoader", true);

    if (this.isAdmin) {
      const toResolv = []

      toResolv.push(this.$dao.clients.getAll().then((users) => this.allClients = users))

      if (this.pathBuildingId) {
        toResolv.push(this.$dao.buildings
            .getById(this.pathBuildingId)
            .then(building => {
              this.selectedBuilding.push(building);
              return building;
            })
            .then(building => this.getClientBuildingsMeters(building.clientId))
        )
      }

      Promise.all(toResolv)
          .finally(() => {
            if (this.selectedBuilding.length > 0 && this.allClients) {
              this.currentClient = this.allClients.find(it => this.selectedBuilding[0].clientId === it.id);
            }

            this.$store.commit("showLoader", false);
          });
    } else {
      this.$dao
          .clients
          .getMe()
          .then((clientBuildings) => {
            this.currentClient = clientBuildings.client;
            this.selectedBuilding.push(clientBuildings?.buildingMeters[0]?.building);
            this.$store.commit('setUserBuildings', clientBuildings?.buildingMeters === null ? [] : clientBuildings.buildingMeters);
          })
          .finally(() => {
            this.$store.commit("showLoader", false);
          })
    }
  }

  ///REMOVE SELECTED METER LINKED TO A BUILDING THAT HAS BEEN REMOVED FROM SELECTED BUILDING LIST
  @Watch('selectedBuilding')
  onSelectedBuilding(): void {
    this.selectedMeters = [];
  }

  ///REMOVE SELECTED METER LINKED TO A TYPE THAT IS NOT SELECTED
  @Watch('selectedTypes')
  onSelectedTypes(val: MeterType[]): void {
    this.selectedMeters = this.selectedMeters.filter((meter) => val.includes(meter.type));
  }

  ///REFRESH DATA
  @Watch('selectedPeriod')
  onSelectedPeriod(): void {
    this.triggerRefreshData();
  }

  ///REFRESH DATA
  @Watch('selectedDate')
  onSelectedDate(): void {
    this.triggerRefreshData();
  }

  //REFRESH DATA
  @Watch('selectedMeters')
  onSelectedMeters(): void {
    this.triggerRefreshData();
  }

  @Watch('currentClient')
  onSelectedClient(curr: Client): void {
    try {
      if (this.isAdmin) {
        this.$store.commit("showLoader", true);

        if (this.selectedBuilding.length > 0 && this.selectedBuilding[0].clientId != curr.id) {
          this.selectedBuilding = null;
        }

        this.getClientBuildingsMeters(curr.id).then(() => this.$store.commit("showLoader", false));
      }
    } catch (e) {
      this.$store.commit("showLoader", false);
      // eslint-disable-next-line no-console -- erreur volontairement journalisée
      console.error(e);
    }
  }

  get noTemperatureMeter(): boolean {
    return this.buildingsMeters.every(buildingMeters => buildingMeters.meters.every(meter => meter.type !== MeterType.TEMPERATURE));
  }

  get periodTitle(): string {
    switch (this.selectedPeriod) {
      case AvailablePeriodType.DAY:
        return `Analyse ${DateUtils.toDDMMYYYY(this.selectedDate)}`;
      case AvailablePeriodType.WEEK:
        return `Analyse de la semaine ${dayjs.utc(this.selectedDate).week()}`
      case AvailablePeriodType.MONTH:
        return `Analyse du mois de ${dayjs.utc(this.selectedDate).format("MMMM")}`
      case AvailablePeriodType.YEAR:
        return `Analyse de l'année ${this.selectedDate.getFullYear()}`;
      case AvailablePeriodType.COMPARATIVE:
        return "Analyse comparative des 3 dernières années";
      default:
        return "";
    }
  }

  get isDayPeriod(): boolean {
    return this.selectedPeriod === AvailablePeriodType.DAY;
  }

  get isComparativePeriod(): boolean {
    return this.selectedPeriod === AvailablePeriodType.COMPARATIVE;
  }

  get pathBuildingId(): string | undefined {
    return this.$route.params.buildingId;
  }

  get isAdmin(): boolean {
    return this.$store.getters.isAdmin;
  }

  get somethingIsLoading(): boolean {
    return Object.values(this.chartsLoading).some(v => v === true);
  }

  //GET ALL USER'S BUILDINGS
  get buildings(): Building[] {
    const buildings = this.$store.state.currentUserBuildings?.map((buildingsMeter) => buildingsMeter.building);

    if (buildings) {
      buildings.sort((a, b) => a.name.localeCompare(b.name));
    }

    return buildings;
  }

  ///GET BUILDINGS AND METERS OF SELECTED BUILDINGS
  get buildingsMeters(): BuildingMeters[] {
    return this.$store.state.currentUserBuildings?.filter((buildings) => this.selectedBuilding.find(it => it.id === buildings.building.id));
  }

  get clientsItems(): { text: string, value: Client }[] {
    return this.allClients?.map((client) => ({'text': client.nameSurname, 'value': client}))
  }

  get formatDate(): string {
    return DateUtils.toDDMMYYYY(this.selectedDate);
  }

  get periodButton(): string[] {
    return Object.values(AvailablePeriodType).filter((value) => value !== AvailablePeriodType.HOURLY);
  }

  get meterTypes(): MeterType[] {
    // On retourne les types de compteur qui sont présents dans les bâtiments sélectionnés.
    // En filtrant les types de compteur qui sont des compteurs de référence
    return Object.keys(MeterType).filter((key) => !REF_METER_TYPE.includes(MeterType[key])).map((key) => MeterType[key]).filter((type) => {
      return this.buildingsMeters?.some((buildingMeters) => {
        return buildingMeters.meters.some((meter) => meter.type === type);
      });
    });
  }

  surfaceBuilding(buildingId: string): number {
    const building = this.buildings.find(it => it.id === buildingId)

    if (building && building.surface > 0) {
      return building.surface
    } else {
      return 1
    }
  }

  get consumptionSeries(): { unit: string, data: any[] } {
    if (this.selectedPeriod === AvailablePeriodType.COMPARATIVE) {
      //EX: {2017: [{},...],2018: [{},...],...]
      let groupByYear: Record<string, MeterReadingMonthlyAggregated[]>[] = this.statConsumption?.map((stat: any) => {
        return stat.values.reduce((acc, curr) => {
          (acc[curr.year] = acc[curr.year] || []).push(curr);
          return acc;
        }, {} as Record<string, MeterReadingMonthlyAggregated[]>);
      });

      const months: number[] = Array(12).fill(false).map((month, index) => index);

      let series: ApexAxisChartSeries = Object.values(groupByYear).map((series) => {
        return Object.entries(series)?.map((serie) => {
          return ({
            name: `${serie[0]} (${Math.floor(serie[1].reduce((acc, curr) => acc += curr.value, 0))} ${this.selectedMeters[0].unit})`,
            data: months.map((month) => {
                  return {
                    x: DateUtils.toLocalMonth(dayjs.utc().month(month).toDate()), y: serie[1].find((value) => {
                      return MeterReadingMonthlyAggregated.map(value).date.getMonth() === month;
                    })?.value,
                  };
                },
            ),
          });
        });
      }).flat();

      return {
        unit: this.selectedMeters[0].unit.toString(),
        data: series,
      };
    } else {
      const periodDates: Date[] = (() => {
        switch (this.selectedPeriod) {
          case AvailablePeriodType.DAY: {
            return Array.from({length: 24}, (_, h) => dayjs.utc(this.selectedDate).hour(h).minute(0).second(0).toDate());
          }
          case AvailablePeriodType.WEEK: {
            const start = dayjs.utc(this.selectedDate).startOf('week');
            return Array.from({length: 7}, (_, i) => start.add(i, 'day').toDate());
          }
          case AvailablePeriodType.MONTH: {
            const start = dayjs.utc(this.selectedDate).startOf('month');
            const days = dayjs.utc(this.selectedDate).daysInMonth();
            return Array.from({length: days}, (_, i) => start.add(i, 'day').toDate());
          }
          case AvailablePeriodType.YEAR: {
            const start = dayjs.utc(this.selectedDate).startOf('month');
            return Array.from({length: 12}, (_, i) => start.add(i, 'month').toDate());
          }
          default:
            return [];
        }
      })();

      let data = (this.statConsumption || []).map((stat) => {
        let name = stat.meter.name;

        return {
          name: name,
          type: 'line',
          unit: this.isRatio ? `${this.selectedMeters[0].unit.toString()} / m²` : this.selectedMeters[0].unit.toString(),
          meterType: stat.meter.type,
          data: periodDates.map(pd => {
            const found = stat.values.find(v => this.formatSerieDate(v.date) === this.formatSerieDate(pd));
            const y = found ? (this.isRatio ? found.value / this.surfaceBuilding(stat.meter.buildingId) : found.value) : 0;
            return { x: this.formatSerieDate(pd), y };
          })
        };
      });

      if ((this.statEnergetic || []).length > 0 && !(this.statEnergetic[0].values.every(value => value.model === 0))) {
        data.push(...(this.statEnergetic || []).map(el => ({
          name: `Modèle ${el.meter.name}`,
          type: 'scatter',
          meterType: el.meter.type,
          unit: this.isRatio ? `${this.selectedMeters[0].unit.toString()} / m²` : this.selectedMeters[0].unit.toString(),
          data: periodDates.map(pd => {
            const found = el.values.find(v => this.formatSerieDate(v.date) === this.formatSerieDate(pd));
            const y = found ? (this.isRatio ? found.model / this.surfaceBuilding(el.meter.buildingId) : found.model) : 0;
            return {x: this.formatSerieDate(pd), y};
          })
        })));
      }

      if ((this.statTemperature || []).length > 0) {
        data.push({
          name: this.meterTemperature ? `${this.meterTemperature.name}` : 'Température',
          type: 'line',
          unit: '°C',
          meterType: MeterType.TEMPERATURE,
          data: periodDates.map(pd => {
            const found = (this.statTemperature || []).find(v => this.formatSerieDate(v.date) === this.formatSerieDate(pd));
            const y = found ? found.value : 0;
            return {x: this.formatSerieDate(pd), y};
          })
        })
      }

      return {unit: this.selectedMeters[0].unit + (this.isRatio ? '/m²' : ''), data}
    }
  }

  get withClimate(): string {
    const climateData = this.statConsumption?.filter(it => it.meter.type === MeterType.CLIMATE_TEMPERATURE) || [];
    return climateData.length > 0 ? 'Climat' : undefined;
  }

get energeticSeries(): { unit: string, data: any[] } | undefined {
  const firstMeter = this.statEnergetic?.find(it => it)

  if (!firstMeter) {
    return undefined
  }

  const data = this.statEnergetic?.map(current => {
    let name = current.meter.name;
 
    const out = [
      {
        name: name,
        unit: current.meter.unit,
        type: 'scatter',
        data: current.values.map(it => ({x: it.temperature, y: this.isRatio ? it.value / this.surfaceBuilding(current.meter.buildingId) : it.value})) || []
      },
      {
        name: `Modèle ${current.meter.name}`,
        unit: current.meter.unit,
        type: 'scatter',
        data: current.values.map(it => ({x: it.temperature, y: this.isRatio ? it.model / this.surfaceBuilding(current.meter.buildingId) : it.model})) || []
      }
    ]

    if (out[1].data.every(point => point.y === 0)) {
      out.splice(1, 1);
    }

    return out;
  })?.flat() || []

  let unit = "";
  if (firstMeter?.meter?.unit) {
    unit = firstMeter.meter.unit + (this.isRatio ? '/m2' : '');
  }

  return {
    unit: unit,
    data
  }
}

  get consumptionDistributionSerie(): { unit: string, data: any } {
    return {
      unit: this.selectedMeters[0].unit + (this.isRatio ? '/m2' : ''),
      data: {
        labels: this.statConsumptionDistribution?.map(item => `${item.meter.name} (${this.$t('meter.units.' + item.meter.unit)}${(this.isRatio ? '/m2' : '')})`),
        values: this.statConsumptionDistribution?.map(item => this.isRatio ? item.value / this.surfaceBuilding(item.meter.buildingId) : item.value),
      },
    };
  }

  get consumptionDistributionEuroSerie(): { unit: string, data: any } {
    return {
      unit: 'chf',
      data: {
        labels: this.statConsumptionDistribution?.map(item => `${item.meter.name} (${item.meter.pricePerUnit}CHF / ${this.$t('meter.units.' + item.meter.unit)}${(this.isRatio ? '/m2' : '')})`),
        values: this.statConsumptionDistribution?.map(item => (this.isRatio ? item.value / this.surfaceBuilding(item.meter.buildingId) : item.value) * item.meter.pricePerUnit),
      },
    };
  }

getRelatedIconColor(meterType: MeterType): string {
  switch (meterType) {
    case MeterType.HEAT:
      return "red lighten-3";
    case MeterType.COLD:
      return "blue lighten-2";
    case MeterType.WATER:
      return "blue darken-1";
    case MeterType.ELECTRICTY:
      return "green lighten-3";
    case MeterType.GAS:
      return "orange lighten-3";
    case MeterType.SANITARY_WATER:
      return "teal lighten-3";
    case MeterType.WIND:
      return "cyan lighten-3";
    case MeterType.LUX:
      return "amber lighten-3";
    case MeterType.TEMPERATURE:
      return "purple lighten-3";
    case MeterType.DEW_POINT:
      return "blue lighten-4";
    case MeterType.CLOUD_FACTOR:
      return "blue-grey lighten-3";
    case MeterType.CHILD:
      return "grey lighten-3"; // Should not happen
    case MeterType.CLIMATE_TEMPERATURE:
      return "yellow lighten-3";
    case MeterType.CLIMATE_HUMIDITY:
      return "indigo lighten-3";
    case MeterType.CLIMATE_CO2:
      return "brown lighten-3";
  }
}

  getRelatedIcon(meterType: MeterType): string {
    switch (meterType) {
      case MeterType.HEAT:
        return "fire";
      case MeterType.COLD:
        return "snowflake";
      case MeterType.WATER:
        return "water";
      case MeterType.ELECTRICTY:
        return "lightning-bolt";
      case MeterType.GAS:
        return "gas-burner";
      case MeterType.SANITARY_WATER:
        return "shower-head";
      case MeterType.WIND:
        return "weather-windy";
      case MeterType.LUX:
        return "weather-sunny";
      case MeterType.TEMPERATURE:
        return "thermometer";
      case MeterType.DEW_POINT:
        return "thermometer-water"
      case MeterType.CLOUD_FACTOR:
        return "cloud";
      case MeterType.CHILD:
        return "help"; // Should not happen
      case MeterType.CLIMATE_TEMPERATURE:
        return "thermometer-lines";
      case MeterType.CLIMATE_HUMIDITY:
        return "water-percent";
      case MeterType.CLIMATE_CO2:
        return "molecule-co2";
    }
  }

  getClientBuildingsMeters(clientId: string): Promise<ClientBuildings> {
    return this.$dao.clients.getClientBuildingMeters(clientId)
        .then(buildingsMeter => {
          this.$store.commit('setUserBuildings', buildingsMeter?.buildingMeters ?? []);
          return buildingsMeter;
        })
  }

  triggerRefreshData(): void {
    if (this.selectedBuilding && this.selectedBuilding.length > 0 && this.selectedMeters.length > 0) {
      this.getConsumptionStats();
      this.getIndexStats();
      this.getConsumptionDistributionStats();
      this.getEnergiticStats();
      this.getTemperatureData();
    }

    this.setPathParameters();
  }

  setPathParameters(): void {
    const urlParams = new URLSearchParams();
    urlParams.set('selectedDate', this.selectedDate.toISOString());
    // urlParams.set('selectedMeters', this.selectedMeters.map(it => it.id).join(','));
    urlParams.set('selectedPeriod', this.selectedPeriod);
    window.location.hash = urlParams.toString();
  }

  extractPathParameters(): void {
    const urlParams = new URLSearchParams(window.location.hash.substring(1));
    const selectedDate = urlParams.get('selectedDate');
    // const selectedMeters = urlParams.get('selectedMeters');
    const selectedPeriod = urlParams.get('selectedPeriod');

    if (selectedDate) {
      this.selectedDate = new Date(selectedDate);
    }

    // if (selectedMeters) {
    //   this.selectedMeters = selectedMeters.split(',').map(it => this.buildingsMeters.flatMap(it => it.meters).find(meter => meter.id === it));
    // }

    if (selectedPeriod) {
      this.selectedPeriod = AvailablePeriodType[selectedPeriod.toUpperCase()];
    }
  }

  metersFiltered(meters: Meter[]): Meter[] {
    const results = meters
        .filter(meter => {
          return this.displayMeterChip(meter) && meter.referenceMeterId == null && meter.type != MeterType.CHILD;
        });

    results.sort((a, b) => a.name.localeCompare(b.name));

    return results;
  }

  displayMeterChip(meter: Meter): boolean {
    if (this.selectedTypes.length > 0) {
      return !REF_METER_TYPE.includes(meter.type) && this.selectedTypes.includes(meter.type);
    }
    return !REF_METER_TYPE.includes(meter.type);
  }

  disabledMeterChip(): boolean {
    // Note: Désactivation le 08/01/2024 suite à la demande de Antoine


    // if (this.selectedMeters.length >= 1) {
    //   return this.selectedMeters[0].unit != meter.unit;
    // }

    return false;
  }

  getConsumptionStats(): void {
    this.$set(this.chartsLoading, 'loadingConsumptionData', true);

    this.$dao.dashboard
        .getConsumptionStats(StatsConsumptionForm.map({period: this.selectedPeriod, metersIds: this.selectedMeters?.map(meter => meter.id), startDate: this.selectedDate}))
        .then((result) => {
          return this.statConsumption = result;
        })
        .finally(() => this.$set(this.chartsLoading, 'loadingConsumptionData', false));
  }

  // Vérification légère (booléen côté API) pour afficher ou non l'entrée « Télécharger les index »
  getIndexStats(): void {
    this.hasIndexes = false;

    this.$dao.dashboard
        .hasIndexStats(StatsConsumptionForm.map({period: this.selectedPeriod, metersIds: this.selectedMeters?.map(meter => meter.id), startDate: this.selectedDate}))
        .then((result) => this.hasIndexes = result)
        // eslint-disable-next-line no-console -- erreur volontairement journalisée
        .catch((e) => console.error(e));
  }

  getTemperatureData(): void {
    this.$set(this.chartsLoading, 'loadingTemperatureData', true);

    this.$dao.dashboard
        .getTemperatureData<GetTemperatureDataForm>(GetTemperatureDataForm.map({period: this.selectedPeriod, startDate: this.selectedDate, buildingId: this.selectedBuilding[0].id}))
        .then((result) => {
          this.statTemperature = result.values;
          this.meterTemperature = result.meter;
        })
        .finally(() => this.$set(this.chartsLoading, 'loadingTemperatureData', false));

  }

  getConsumptionDistributionStats(): void {
    this.$set(this.chartsLoading, 'loadingConsumptionDistributionData', true);

    this.$dao.dashboard
        .getConsumptionDistributionStats(StatsConsumptionForm.map({period: this.selectedPeriod, metersIds: this.selectedMeters?.filter(it => it.type != MeterType.CLIMATE_TEMPERATURE).map(meter => meter.id), startDate: this.selectedDate}))
        .then((result) => this.statConsumptionDistribution = result)
        .finally(() => this.$set(this.chartsLoading, 'loadingConsumptionDistributionData', false));
  }

  getEnergiticStats(): void {
    if (this.isDayPeriod || this.isComparativePeriod) {
      this.statEnergetic = [];
    } else {
      this.$set(this.chartsLoading, 'loadingEnergeticData', true);

      this.$dao.dashboard
          .getEnergeticSignatureStats(StatsForm.map({buildingId: this.selectedBuilding[0].id, metersIds: this.selectedMeters?.map(meter => meter.id), startDate: this.selectedDate, period: this.selectedPeriod}))
          .then((result) => this.statEnergetic = result)
          .finally(() => this.$set(this.chartsLoading, 'loadingEnergeticData', false));
    }
  }

  formatSerieDate(date: Date | string): string {
    let formatDate: string;
    switch (this.selectedPeriod) {
      case AvailablePeriodType.DAY:
        formatDate = DateUtils.toHHmm(date);
        break;
      case AvailablePeriodType.WEEK:
        formatDate = DateUtils.toLocalWeekDay(date);
        break;
      case AvailablePeriodType.MONTH:
        // Demande Antoine 07/09/2020 les periodes par mois, sont maintenant groupé par jour et non plus par semaine.
        // formatDate = DateUtils.toWeekNumber(date);
        formatDate = DateUtils.toLocalDay(date);
        break;
      case AvailablePeriodType.YEAR:
        formatDate = DateUtils.toLocalMonthYear(date);
        break;
      case AvailablePeriodType.COMPARATIVE:
        formatDate = DateUtils.toLocalMonth(date);
        break;
    }

    return formatDate;
  }

  pickDate(isoDate: string): void {
    this.selectedDate = DateUtils.isoStringToDate(isoDate);
    this.datePickerOpen = false;
  }

  get exportHeaders(): Record<string, string> {
    return {
      meterName: 'Nom du compteur',
      meterType: 'Type du compteur',
      meterUnit: 'Unité du compteur',
      meterId: 'Id du compteur',
      meterDate: 'Date',
      meterValue: 'Valeur'
    }
  }

  get exportFileName(): string {
    return `${this.selectedMeters.map(it => it.name).join("-")}_${this.selectedPeriod}`;
  }

  // Une ligne CSV par valeur, avec les informations du compteur
  private flattenStatsForExport(data: StatsConsumptionResponse<MeterReading>[]) {
    const output = []
    data.forEach((stats) => {
      stats.values.forEach((it) => {
        output.push({meterName: stats.meter.name, meterType: stats.meter.type, meterUnit: stats.meter.unit, meterId: stats.meter.id, meterDate: it.date, meterValue: it.value.toFixed(2)})
      })
    })
    return output;
  }

  // Export de l'analyse (consommations agrégées + climat) sur la période en cours
  async exportCSVValues(): Promise<void> {
    this.exporting = true;
    try {
      const data = await this.$dao.dashboard
          .getConsumptionStats<MeterReading>(StatsConsumptionForm.map({
            buildingId: this.selectedBuilding[0].id,
            period: this.selectedPeriod == AvailablePeriodType.DAY ? AvailablePeriodType.HOURLY : this.selectedPeriod,
            metersIds: this.selectedMeters?.map(meter => meter.id),
            startDate: this.selectedDate,
            dl: true
          }))

      exportCSVFile(this.exportHeaders, this.flattenStatsForExport(data), this.exportFileName);
    } finally {
      this.exporting = false;
    }
  }

  // Export des index bruts (idx_conso) sur le même intervalle que l'analyse en cours
  async exportCSVIndexes(): Promise<void> {
    this.exporting = true;
    try {
      const data = await this.$dao.dashboard
          .getIndexStats<MeterReading>(StatsConsumptionForm.map({
            period: this.selectedPeriod,
            metersIds: this.selectedMeters?.map(meter => meter.id),
            startDate: this.selectedDate
          }))

      exportCSVFile(this.exportHeaders, this.flattenStatsForExport(data), `${this.exportFileName}_index`);
    } finally {
      this.exporting = false;
    }
  }

}
